module.exports = __webpack_public_path__ + "static/bbot-fc3364f32f1796b8da9a374eba6f0b42.png";